export enum StringBoolean {
  True = "true",
  False = "false",
}
